import { cn } from '@workspace/ui/lib/utils'
import { Link } from '@tanstack/react-router'

export function Logo({ className, withName = true }: { className?: string; withName?: boolean }) {
    return (
        <Link to="/" className={cn('flex-shrink-0 flex items-center gap-2 w-fit', className)}>
            <img src="/logo.png" alt="Admin Panel Logo" className="w-10 h-10" />
            {withName && (
                <div className="flex flex-col justify-center">
                    {withName && <span className="font-bold text-sm leading-[1.43]">Quản lý phát triển dự án</span>}
                </div>
            )}
        </Link>
    )
}
